// extracted by mini-css-extract-plugin
export default {"course-container":"Course_course-container__K1EmT","tab-container":"Course_tab-container__7vjMU"};